export const PHONE_DISPLAY = '+92 316 7441329';
export const PHONE_E164 = '+923167441329';

const WHATSAPP_NUMBER = '923167441329';

export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

export const WHATSAPP_URL = whatsappLink();

export const PRICING_WHATSAPP_URL = whatsappLink(
  "Hi Zepliq! I'd like to know the pricing for WhatsApp automation."
);
